import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActiveModal} from "@catmodules/widgets/slide-in-modal/utils/modal-ref";
import {isNullOrUndefined} from "util";
import {LinkedEntitiesService} from "@catmodels/linked-entities/services/linked-entities.service";
import {StyleType} from "@catui/types";
import {EntityTypeStrings, LinkedEntitiesModalTypes} from "@catmodels/linked-entities/types";
import {sortByLabelFunc} from "@catcore/utils";

@Component({
  selector: 'cat-add-delete-entity',
  templateUrl: './add-delete-entity.component.html',
  styleUrls: ['./add-delete-entity.component.scss'],
})
export class AddDeleteEntityComponent implements OnInit {

  @Input() entityType;
  @Input() featureLevel = true;
  @Input() modalType;

  @Input()
  set linkedEntities(value) {
    this._linkedEntities = value;
  }

  @Output() afterUpdate = new EventEmitter();

  _selectableEntities = [];
  styleType = StyleType;

  private _linkedEntities;

  constructor(private _activeModal: ActiveModal,
              private _linkedEntitiesService: LinkedEntitiesService) {
  }

  ngOnInit() {
    if (!isNullOrUndefined(this._linkedEntities)) {
      // if we don't want to delete any entities, we need to request the applicable entities from backend
      if (this.modalType !== LinkedEntitiesModalTypes.Delete) {
      const optionSubscription = this._linkedEntitiesService.getSelectableEntities(this._linkedEntities.resourceUri, this.entityType, this.featureLevel)
        .finally(() => optionSubscription.unsubscribe())
        .subscribe((options) => {
          options.forEach((option, index) => {
            const item = {
              label: option.label,
              value: option.value,
              selected: false,
            };
            this._selectableEntities.push(item);
          });
          this._selectableEntities.sort(sortByLabelFunc);
          this.initSelection();
        });
      } else {
        // build selectable items from linked entities children
        this._linkedEntities.children.forEach((entity) => {
          const item = {
            label: entity.label,
            value: entity.href,
            selected: false,
          };
          this._selectableEntities.push(item);
        });
        this._selectableEntities.sort(sortByLabelFunc);
      }
    }
  }

  /**
   *
   * @param {Event} event
   */
  close(event: Event) {
    // TODO: Is there something to clean up?
    this._activeModal.close();
  }

  /**
   *
   * @param {Event} event
   */
  addDeleteSelected(event: Event) {
    let values = [];
    if (this.modalType === LinkedEntitiesModalTypes.Delete) {
      const selection = this.getSelectedEntities();
      values = this._selectableEntities
        .filter((item) => selection.indexOf(item) < 0)
        .map((item) => item.value);
    } else {
      values = this.getSelectedEntities()
        .map((item) => item['value']);
    }
    this._linkedEntitiesService.setEntities(
        this._linkedEntities.resourceUri,
        values,
        this.entityType
      ).subscribe((result) => {
        this.afterUpdate.emit(result);
        this._activeModal.close();
    });

  }

  /**
   * @returns {string}
   */
  getModalTitle() {
    let mainTitle = 'Select Entities';
    switch (this.modalType) {
      case LinkedEntitiesModalTypes.Delete:
        mainTitle = mainTitle + ' to delete';
        break;
      default:
        break;
    }

    return mainTitle;
  }

  /**
   * @returns {string}
   */
  getButtonLabel() {
    if (this.modalType === LinkedEntitiesModalTypes.Add) {
      return 'Set';
    } else if (this.modalType === LinkedEntitiesModalTypes.Delete) {
      return 'Delete';
    } else {
      return 'Do Stuff';
    }
  }

  /**
   * @returns {any}
   */
  getButtonStyle() {
    if (this.modalType === LinkedEntitiesModalTypes.Delete) {
      return this.styleType.alert;
    } else {
      return this.styleType.success;
    }
  }

  getSelectedEntities() {
    return this._selectableEntities.filter((item) => item.selected);
  }

  /**
   * @param item
   */
  onClick(item) {
    item.selected = !item.selected;
    // Clear others if single-select
    if (this._linkedEntities.onlyOneEntity) {
      this._selectableEntities
        .filter((e) => e !== item)
        .forEach((e) => { e.selected = false });
    }
  }

  private initSelection() {
    if (this.modalType === LinkedEntitiesModalTypes.Add) {
      const selectedUris = this._linkedEntities.children.map((child) => child.href);
      this._selectableEntities
        .filter((item) => selectedUris.indexOf(item['value']) >= 0)
        .forEach((item) => {
          item.selected = true;
        });
    }
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/linked-entities/components/add-entity/add-delete-entity.component.ts